/**
 * AI prompt tracking shortcuts.
 */
import { TrackPrompt, PromptFeedbackConfig } from "../../features/core/track-prompt";

export class PromptTracker {
  constructor(public readonly client: TrackPrompt) {}

  /** A user submitted a prompt. */
  submitted(promptId: string, promptType: string, properties?: Record<string, unknown>) {
    return this.client.trackSubmission({ promptId, promptType, properties });
  }

  /** The model returned a response. */
  responded(promptId: string, responseTime: number, completed: boolean, properties?: Record<string, unknown>) {
    return this.client.trackResponse({ promptId, responseTime, completed, properties });
  }

  /** User feedback on a prompt response (thumbs up/down etc.). */
  feedback(promptId: string, feedbackType: PromptFeedbackConfig["feedbackType"], properties?: Record<string, unknown>) {
    return this.client.trackFeedback({ promptId, feedbackType, properties });
  }

  /** Multi-turn conversation summary. */
  conversation(conversationId: string, userId: string, turnCount: number, totalDuration: number) {
    return this.client.trackConversation(conversationId, userId, turnCount, totalDuration);
  }

  /** Generic prompt event. */
  event(eventName: string, properties: Record<string, unknown> = {}) {
    return this.client.create({ eventName, properties });
  }
}
